module.exports = __webpack_public_path__ + "static/img/1_2_3_1.d37b1698.jpg";